module.exports = __webpack_public_path__ + "media/public/images/icon-search-white-ce746f42e27e1845e57e77e24d24ca67.png";